// src/utils/audioUtils.js

let audioContext = null;

// Inisialisasi AudioContext saat ada interaksi pengguna
const initAudioContext = () => {
    if (!audioContext) {
        try {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
        } catch (e) {
            console.warn('Web Audio API is not supported in this browser.');
        }
    }
    return audioContext;
};

// Fungsi untuk memainkan suara klik tombol yang sederhana
export const playButtonSound = () => {
    const ctx = initAudioContext();
    if (!ctx) return;
    
    // Resume context jika dalam keadaan suspended (kebijakan autoplay browser)
    if (ctx.state === 'suspended') {
        ctx.resume();
    }

    try {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.type = 'sine'; // Gelombang suara yang lembut
        oscillator.frequency.setValueAtTime(600, ctx.currentTime);
        oscillator.frequency.exponentialRampToValueAtTime(300, ctx.currentTime + 0.1);
        
        gainNode.gain.setValueAtTime(0.2, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.1);
        
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.1);
    } catch (e) {
        console.warn('Audio playback failed', e);
    }
};